import { render, staticRenderFns } from "./tabla.vue?vue&type=template&id=2dac5af6&scoped=true&"
import script from "./tabla.vue?vue&type=script&lang=ts&"
export * from "./tabla.vue?vue&type=script&lang=ts&"
import style0 from "./tabla.vue?vue&type=style&index=0&id=2dac5af6&prod&scoped=true&lang=css&"
import style1 from "./tabla.vue?vue&type=style&index=1&id=2dac5af6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dac5af6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VList,VListItem,VProgressLinear,VRow,VSpacer})
